import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useContacts() {
  const q = useQuery({ queryKey: ["company-contacts"], queryFn: () => api.get("/public/company-contacts").then((r) => r.data.items), staleTime: 3600000 });
  return q.data || {};
}

export function MailLink({ k, className = "underline font-medium", children }) {
  const c = useContacts()[k];
  if (!c) return null;
  return <a href={`mailto:${c.email}`} className={className} data-testid={`mailto-${k}`}>{children || c.email}</a>;
}

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = `${title} | 86’d Operations`;
    const m = document.querySelector('meta[name="description"]');
    const prev = m?.content;
    if (m && description) m.content = description;
    return () => { if (m && prev) m.content = prev; };
  }, [title, description]);
}
